import { useRadioGroup, Box } from "@chakra-ui/react";
import RadioCard from "../../components/RadioCard";
import { useState, useEffect } from "react";
import { Inference } from "../../types/inferences";

type ReclassificationOptionsProps = {
  initialValue: string | undefined;
  onChange: (value: string) => Promise<void> | undefined;
  disabled: boolean;
  options: string[];
  selectedInference: Inference;
  validate: (options: {
    validationId: number;
    isValid: boolean;
    compositeIds?: number[];
  }) => Promise<void> | undefined;
  predictedSpecies: string;
};

function ReclassificationOptions({
  options,
  initialValue,
  onChange,
  disabled,
  selectedInference,
  validate,
  predictedSpecies,
}: ReclassificationOptionsProps) {
  const [selected, setSelected] = useState(initialValue || "");
  useEffect(() => {
    setSelected(initialValue || "");
  }, [initialValue, selectedInference.properties.id]);

  // Reset selection when inference becomes valid
  useEffect(() => {
    if (selectedInference.properties.is_valid === true) {
      setSelected("");
    }
  }, [selectedInference.properties.is_valid]);

  const { getRootProps, getRadioProps } = useRadioGroup({
    name: "selected_class",
    value: selected,
    onChange: async (value) => {
      setSelected(value);
      if (onChange) {
        await onChange(value);
        if (selectedInference?.properties?.id !== undefined) {
          validate({
            validationId: selectedInference.properties.id,
            isValid: false
          });
        }
      }
    },
  });

  const group = getRootProps();
  return (
    <Box display="flex" gap="2" flexDir="column" {...group}>
      {options.map((value) => {
        const radio = getRadioProps({ value });
        const isPredictedSpecies =
          value.toLowerCase() === predictedSpecies.split("-")[0].toLowerCase();
        return (
          <RadioCard
            key={value}
            {...radio}
            isDisabled={disabled || isPredictedSpecies}
          >
            {value}
          </RadioCard>
        );
      })}
    </Box>
  );
}

export default ReclassificationOptions;
